import { IconButton } from '../components/IconButton';
import { IconView } from '../components/icons';
import Pagination from '../components/Pagination';
import { useConfig } from '../context/ConfigContext';
import { formatMoney } from '../utils/format';
import usePaginatedList from '../hooks/usePaginatedList';

interface BatchRow {
  id: number;
  batch_number: string;
  status: string;
  total_amount: string;
  lines_count: number;
}

const STATUS_BADGE: Record<string, string> = {
  open: 'badge-scheduled',
  exported: 'badge-neutral',
  disbursed: 'badge-active',
};

const NO_FILTERS = {};

export function BenefitPaymentBatches() {
  const { settings } = useConfig();
  const { data, loading, error, setPage } = usePaginatedList<BatchRow>('/benefit-payment-batches', NO_FILTERS);

  const fmtMoney = (n: string) => formatMoney(Number(n), settings.currency);

  return (
    <>
      <header className="page-header">
        <h1>EFT Payment Batches</h1>
      </header>

      <div className="card">
        <div className="table-scroll">
          <table>
            <thead>
              <tr>
                <th>Batch Number</th>
                <th>Lines</th>
                <th>Total Amount</th>
                <th>Status</th>
                <th></th>
              </tr>
            </thead>
            <tbody>
              {loading ? (
                <tr>
                  <td colSpan={5} className="muted center">
                    Loading…
                  </td>
                </tr>
              ) : error ? (
                <tr>
                  <td colSpan={5} className="error center">
                    {error}
                  </td>
                </tr>
              ) : data && data.data.length > 0 ? (
                data.data.map((batch) => (
                  <tr key={batch.id}>
                    <td className="muted">{batch.batch_number}</td>
                    <td>{batch.lines_count}</td>
                    <td>{fmtMoney(batch.total_amount)}</td>
                    <td>
                      <span className={`badge ${STATUS_BADGE[batch.status] ?? 'badge-neutral'}`}>{batch.status}</span>
                    </td>
                    <td className="right">
                      <IconButton icon={IconView} label="View" to={`/memberships/benefits/payment-batches/${batch.id}`} />
                    </td>
                  </tr>
                ))
              ) : (
                <tr>
                  <td colSpan={5} className="muted center">
                    No payment batches yet.
                  </td>
                </tr>
              )}
            </tbody>
          </table>
        </div>
        <Pagination meta={data} onPage={setPage} />
      </div>
    </>
  );
}
